Vue.component('v2-brand-model-select-box', require('./VueComponents/v2/BrandModelSelectionBar').default);

// navigation elements
Vue.component('faaren-footer', require('./VueComponents/v2/Navigation/Footer').default);

Vue.component('faaren-navbar', require('./VueComponents/v2/Navigation/NavBar').default);

Vue.component('global-banner', require('./VueComponents/v2/GlobalBanner').default);

// navbar components
Vue.component('grey-button', require('./VueComponents/frontend/components/atoms/buttons/GreyButton').default);
Vue.component('contact-modal-icon-container', require('./VueComponents/frontend/components/atoms/buttons/ContactModalIconContainer.vue').default);
Vue.component('contact-button', require('./VueComponents/frontend/components/atoms/buttons/ContactButton').default);
Vue.component('contact-button-mobile', require('./VueComponents/frontend/components/atoms/buttons/ContactButtonMobile').default);
Vue.component('contact-modal', require('./VueComponents/frontend/components/organisms/ContactModal').default);
Vue.component('seperator-x', require('./VueComponents/frontend/components/organisms/SeperatorX').default);
// pds
// migrated pds elements
Vue.component("google-rating", require("./VueComponents/v2/GoogleRating").default);

// legacy pds elements
Vue.component("rating", require("./VueComponents/Helpers/Rating").default)

//footer newsletter
Vue.component('footer-newsletter-modal', require('./VueComponents/v2/Navigation/NewsletterModal').default);
